import script from "./CRM60_008INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM60_008INS.vue?vue&type=script&setup=true&lang=js"

import "./CRM60_008INS.vue?vue&type=style&index=0&id=5052a59a&scoped=true&lang=css"
import "./CRM60_008INS.vue?vue&type=style&index=1&id=5052a59a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5052a59a"]])

export default __exports__